// Translations
import landing from '../views/landing/translations/ru'

// Translation: Verification (Russian)
export default Object.freeze({
	name: '',
	views: { landing }
})
